module.exports = __webpack_public_path__ + "_app/img/pwc.560032b3.svg";